export default __webpack_public_path__ + "static/media/9-min.7915d66e.jpg";